import React from 'react';
import PropTypes from 'prop-types';
import { Visible, Spacer } from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';
import { DetailRow } from 'src/components';
import {
  ALIQUOTS_CHECKED,
  ALIQUOTS_NUMBER,
  ALIQUOTS_VOLUME,
  CONCENTRATION,
  CONCENTRATION_UNIT,
  NORMALIZATION,
  VOLUME,
  VOLUME_UNIT,
  NORMALIZATION_OPTIONS,
  CLOSED_ANSWERS,
  ALL_UNITS,
} from 'src/constants/forms';
import { SummarySectionTitle } from 'src/components/OligoDNA/components/Summary/components';
import RemaindersDetails from '../RemaindersDetails';
import messages from '../../messages';

const getDisplayVolumeConcentration = (details, isVolume) => {
  const dataKey = isVolume ? VOLUME : CONCENTRATION;
  const unitDataKey = isVolume ? VOLUME_UNIT : CONCENTRATION_UNIT;

  return `${details[dataKey]?.value || ''} ${
    ALL_UNITS.find((item) => item.value === details[unitDataKey]?.value)
      ?.label || ''
  }`;
};

const messagesByValues = {
  [NORMALIZATION_OPTIONS.NONE]: messages.none,
  [NORMALIZATION_OPTIONS.VOLUME]: messages.volume,
  [NORMALIZATION_OPTIONS.CONCENTRATION]: messages.concentration,
  [NORMALIZATION_OPTIONS.CONCENTRATION_VOLUME]: messages.volumeAndConcentration,
  [CLOSED_ANSWERS.yes]: messages.yes,
  [CLOSED_ANSWERS.no]: messages.no,
};

const NormalizationAliquotsDetailsComponent = ({
  details,
  showTitle,
  onEditClick,
}) => {
  const normalizationValue = details[NORMALIZATION]?.value;
  const normalizationVolVisible =
    normalizationValue !== NORMALIZATION_OPTIONS.NONE &&
    normalizationValue !== NORMALIZATION_OPTIONS.CONCENTRATION &&
    normalizationValue !== '';
  const normalizationConcentrationVisible =
    normalizationValue !== NORMALIZATION_OPTIONS.NONE &&
    normalizationValue !== NORMALIZATION_OPTIONS.VOLUME &&
    normalizationValue !== '';
  const aliquotsChecked = details[ALIQUOTS_CHECKED]?.value;

  return (
    <>
      <Visible when={showTitle}>
        <SummarySectionTitle
          titleMessage={messages.normalizationAndAliquotsSubTitle}
          onEditClick={onEditClick}
        />
        <Spacer bottom={8} />
      </Visible>
      <Visible when={Object.keys(details)?.length}>
        <DetailRow
          label={messages.normalization}
          value={(
            <Message
              message={messagesByValues[details[NORMALIZATION]?.value]}
            />
          )}
          dots
        />
        <Spacer bottom={8} />
        <Visible when={normalizationVolVisible}>
          <DetailRow
            label={messages.volume}
            value={getDisplayVolumeConcentration(details, true)}
            dots
            inline
          />
          <Spacer bottom={8} />
        </Visible>
        <Visible when={normalizationConcentrationVisible}>
          <DetailRow
            label={messages.concentration}
            value={getDisplayVolumeConcentration(details)}
            dots
            inline
          />
          <Spacer bottom={8} />
        </Visible>
      </Visible>
      {/* ALIQUOTS  */}
      <Visible when={
        normalizationValue &&
        normalizationValue !== NORMALIZATION_OPTIONS.NONE &&
        normalizationValue !== NORMALIZATION_OPTIONS.CONCENTRATION_VOLUME
      }
      >
        <DetailRow
          label={messages.aliquots}
          value={(
            <Message
              message={
                messagesByValues[
                  aliquotsChecked ? CLOSED_ANSWERS.yes : CLOSED_ANSWERS.no
                ]
              }
            />
          )}
          dots
        />
        <Spacer bottom={8} />

        <Visible when={details[ALIQUOTS_CHECKED]?.value}>
          <DetailRow
            label={messages.number}
            value={details[ALIQUOTS_NUMBER]?.value}
            dots
            inline
          />
          <Spacer bottom={8} />
          <DetailRow
            label={messages.volume}
            value={details[ALIQUOTS_VOLUME]?.value}
            dots
            inline
          />
          <Spacer bottom={8} />
        </Visible>
      </Visible>
      {/* END ALIQUOTS  */}
      {/* REMAINDERS  */}
      <RemaindersDetails visible={
        aliquotsChecked &&
        normalizationValue !== NORMALIZATION_OPTIONS.NONE &&
        normalizationValue !== NORMALIZATION_OPTIONS.CONCENTRATION_VOLUME
      }
      />
      {/* END REMAINDERS  */}
    </>
  );
};

NormalizationAliquotsDetailsComponent.propTypes = {
  details: PropTypes.object.isRequired,
  showTitle: PropTypes.bool,
  onEditClick: PropTypes.func,
};

export default NormalizationAliquotsDetailsComponent;
